import { Config } from "@/api/AppApi/config";
import ApiService from "@/api/baseApi/api-service";

class Reminder extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  remindEmail = (body: {
    email: string;
    product: number;
    language: "en" | "ar";
  }): Promise<any> => {
    return this.post(`products/${body.product}/stock-reminder`, {
      email: body.email,
      language: body.language,
    });
  };
  remindPhone = (body: {
    mobile?: {
      number: any;
      country: any;
    };
    product: number;
    language: "en" | "ar";
  }): Promise<any> => {
    return this.post(`products/${body.product}/stock-reminder`, {
      mobile: body.mobile,
      language: body.language,
    });
  };
}
export default Reminder;
